import { Util } from './_util.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import Swiper, { Navigation, Pagination, Scrollbar, Parallax, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Parallax, Autoplay]);
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

var device = 'mobile',
    prev = 0;

const App = {
  checkTouchDevice: function () {
    if ("ontouchstart" in document.documentElement){
      $('body').addClass('touch-device');
    } else {
      $('body').addClass('no-touch-device');
    }
  },

  animateElements: function () {
    $(window).on('scroll', function(){
      var scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height(),
          documentHeight = $(document).height(),
          bottomOfWindow = $(window).scrollTop() + $(window).height();
      if (documentHeight > windowHeight) {
        if ((scrollTop > 50) && (scrollTop + windowHeight < documentHeight - 150)) {
          $('.header').toggleClass('header--hide', scrollTop > prev);
        } else if (scrollTop + windowHeight >= documentHeight - 150) {
          $('.header').addClass('header--hide');
        } else {
          $('.header').removeClass('header--hide');
        }
      } else {
        $('.header--hide').removeClass('header--hide');
      }
      $('.header').toggleClass('header--scroll', scrollTop > 250);
      prev = scrollTop;
      $('.news-grid-module__item, .faq-module__item').each( function(){
        var windowWidth = $(window).innerWidth();
        var topOfObject = $(this).offset().top;
        if(windowWidth > 980){
          topOfObject = $(this).offset().top + 80;
        } else if ((windowWidth < 981) && (windowWidth > 760)) {
          topOfObject = $(this).offset().top + 60;
        } else {
          topOfObject = $(this).offset().top + 40;
        }
        if(bottomOfWindow > topOfObject){
          $(this).addClass('animate');
        }
      });
      $('.news-grid-module__item.animation, .faq-module__item.animation').each( function(){
        var windowWidth = $(window).innerWidth();
        var topOfObject = $(this).offset().top;
        if(windowWidth > 980){
          topOfObject = $(this).offset().top + 80;
        } else if ((windowWidth < 981) && (windowWidth > 760)) {
          topOfObject = $(this).offset().top + 60;
        } else {
          topOfObject = $(this).offset().top + 40;
        }
        if(bottomOfWindow > topOfObject){
          $(this).addClass('animate');
        }
      });
    });
  },

  checkDeviceWidth: function () {
    $(window).on("resize", function() {
      $(window).trigger('scroll');
			var windowWidth = $(window).innerWidth();
			if(windowWidth > 980){
				if(device == 'mobile'){
					$('.header').removeClass('header--open');
					$('.main-menu').removeClass('main-menu--open');
          $('.main-menu__link.touch-active').removeClass('touch-active');
          $('.sub-menu__list').slideUp(0);
          $('.main-menu__toggle-btn--close').removeClass('main-menu__toggle-btn--close');
          $('html').removeClass('hidden');
					device = 'desktop';
				}
			} else {
				if(device == 'desktop'){
					$('.main-menu').removeClass('main-menu--open');
          $('.main-menu__link.touch-active').removeClass('touch-active');
          $('.sub-menu__list').slideUp(0);
					device = 'mobile';
				}
			}
		}).resize();
  },

  checkHash: function () {
    $(function() {
      const hash = document.URL.substr(document.URL.indexOf('#')+1);
      $('.faq-module__filter-btn--' + hash).trigger('click');
    });
    $(window).on('hashchange', function(e){
      const hash = document.URL.substr(document.URL.indexOf('#')+1);
      $('.faq-module__filter-btn--' + hash).trigger('click');
    });
  },

  controlAnimation: function () {
    $(window).on("resize", function() {
      $("body").addClass("no-animation");
      setTimeout(function(){
          $(".no-animation").removeClass("no-animation");
      }, 200);
    }).resize();
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
          currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  controlMainMenu: function () {
    function openMainMenu() {
      $('.header').addClass('header--open');
      $('.main-menu').scrollTop(0);
      $('.main-menu__toggle-btn').addClass('main-menu__toggle-btn--close');
      $('.sub-menu__list').fadeOut(0);
      $('.sub-menu__list').slideUp(0);
      $('html').addClass('hidden');
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.main-menu__toggle-btn').removeClass('main-menu__toggle-btn--close');
      setTimeout(function() { 
        $('.main-menu .touch-active').removeClass('touch-active');
      }, 400);
      $('html').removeClass('hidden');
    }

    $('.main-menu__toggle-btn').on('click',function(){
      if($(this).hasClass('main-menu__toggle-btn--close')){
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });

    $('.no-touch-device .main-menu__item').on('mouseenter',function(){
      if(device == 'desktop'){
        $(this).children('.sub-menu__list').stop().slideDown(300);
      }
    }).on('mouseleave',function(){
      if(device == 'desktop'){
        $(this).children('.sub-menu__list').stop().slideUp(300);
      }
    });

    $('.no-touch-device .main-menu__link').on('click',function(e){
      if(device == 'mobile'){
        if($(this).siblings('.sub-menu__list').length > 0){
          e.preventDefault();
          if($(this).siblings('.sub-menu__list').is(':visible')) {
            $(this).siblings('.sub-menu__list').stop().slideUp(300);
            $(this).removeClass('touch-active');
          } else {
            $(this).siblings('.sub-menu__list').stop().slideDown(300);
            $(this).addClass('touch-active');
            $('.no-touch-device .main-menu__link').not(this).siblings('.sub-menu__list').stop().slideUp(300);
            $('.no-touch-device .main-menu__link').not(this).removeClass('touch-active');
          }
        }
      }
    });

    $('.touch-device .main-menu__link').on('click',function(e){
      e.preventDefault();
      if($(this).siblings('.sub-menu__list').length > 0){
        if($(this).siblings('.sub-menu__list').is(':visible')) {
          $(this).siblings('.sub-menu__list').stop().slideUp(300);
          $(this).removeClass('touch-active');
        } else {
          $(this).siblings('.sub-menu__list').stop().slideDown(300);
          $(this).addClass('touch-active');
          $('.touch-device .main-menu__link').not(this).siblings('.sub-menu__list').stop().slideUp(300);
          $('.touch-device .main-menu__link').not(this).removeClass('touch-active');
        }
      } else {
        var newUrl = $(this).attr('href');
        var newUrlTarget = $(this).attr('target');
        $(this).addClass('touch-active');
        $('.main-menu__link').not(this).removeClass('touch-active');
        setTimeout(function(){
          if(newUrlTarget == "_blank") {
            window.open(newUrl);
          } else {
            window.location = newUrl;
          }
        },300);
      }
    });

    $('.touch-device .sub-menu__link').on('click',function(e){
      e.preventDefault();
      var newUrl = $(this).attr('href');
      var newUrlTarget = $(this).attr('target');
      $(this).addClass('touch-active');
      $('.sub-menu__link').not(this).removeClass('touch-active');
      setTimeout(function(){
        if(newUrlTarget == "_blank") {
          window.open(newUrl);
        } else {
          window.location = newUrl;
        }
      },300);
    });

    $('.sub-menu__list').each(function(){
      $(this).parent('.main-menu__item').addClass('main-menu__item--has-sub-menu');
      $(this).siblings('.main-menu__link').addClass('main-menu__link--has-sub-menu');
    });
  },

  filterNews: function () {
    $('.news-grid-module__filter-btn').on('click',function(e){
      e.preventDefault();
      var filter = $(this).attr('data-id');
      $('.news-grid-module__filter-btn--current').removeClass('news-grid-module__filter-btn--current');
      $(this).addClass('news-grid-module__filter-btn--current');
      $('.news-grid-module__item').removeClass('animate').hide();
        if(filter == 'latest'){
          $('.news-grid-module__item').addClass('animation').show();
        } else {
          $('.news-grid-module__item.' + filter).addClass('animation').show();
        }
      setTimeout(function(){
        $(window).trigger('scroll');
      }, 100);
    });
  },

  filterFAQ: function () {
    $('.faq-module__filter-btn').on('click',function(){
      $('.faq-module__item-question--active').removeClass('faq-module__item-question--active');
      $('.faq-module__item-answer').slideUp(0);
      var filter = $(this).attr('data-id');
      $('.faq-module__filter-btn--current').removeClass('faq-module__filter-btn--current');
      $(this).addClass('faq-module__filter-btn--current');
      $('.faq-module__item').removeClass('animate').hide();
        if(filter == 'all'){
          $('.faq-module__item').addClass('animation').show();
        } else {
          $('.faq-module__item.' + filter).addClass('animation').show();
        }
      setTimeout(function(){
        $(window).trigger('scroll');
      }, 100);
    });


    $('.faq-module__item-question').on('click',function(){
      if($(this).siblings('.faq-module__item-answer').is(":visible")){
        $(this).removeClass('faq-module__item-question--active');
        $(this).siblings('.faq-module__item-answer').slideUp(300);
      } else {
        $(this).addClass('faq-module__item-question--active');
        $(this).siblings('.faq-module__item-answer').slideDown(300);
        $('.faq-module__item-question').not(this).removeClass('faq-module__item-question--active');
        $('.faq-module__item-question').not(this).siblings('.faq-module__item-answer').slideUp(300);
      }
    });
  },

  initGSAP: function () {
    const floatingIcon = gsap.utils.toArray('.floating-icon');
    let matchMedia = gsap.matchMedia();
    matchMedia.add(
      {
        isDesktop: '(min-width: 981px)',
        isTablet: '(max-width: 980px) and (min-width: 761px)',
        isMobile: '(max-width: 760px)',
      },
      (context) => {
        let { isDesktop, isTablet, isMobile } = context.conditions;

        floatingIcon.forEach((section) => {
          gsap.to(section, {
            scrollTrigger: {
              trigger: section,
              scrub: 1,
              invalidateOnRefresh: true,
            },
            yPercent: '-100',
            rotate: '-20',
            ease: 'sine',
          });
        });
      }
    )
  },

  initSwipers: function () {
    $('.swiper-container').each(function (index) {
      const navigationVar = 's'+index;
      $(this).children('.swiper-button').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        effect: 'slide',
        slidesPerView: 'auto',
        parallax: true,
        speed: 600,
        loop: true,
        grabCursor: true,
        autoplay: false,
        simulateTouch: true,
        navigation: {
          nextEl: '.swiper-button--next.' + navigationVar,
          prevEl: '.swiper-button--prev.' + navigationVar,
        },
      });
    });
  },

  init: function () {
    this.checkTouchDevice();
    this.animateElements();
    this.checkDeviceWidth();
    this.checkHash();
    this.controlAnimation();
    this.controlMainMenu();
    this.filterNews();
    this.filterFAQ();
    this.getCopyrightYear();
    this.initGSAP();
    this.initSwipers();
  },
};

export default App;
